var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentsInActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "30px",
    viewBox: "0 0 24 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP_Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "#D1D3D4",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Options",
    className: "premiumIcon",
    transform: "translate(-81.000000, -166.000000)",
    fill: "#D1D3D4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,166 L84,166 C82.35,166 81.015,167.35 81.015,169 L81,193 C81,194.65 82.335,196 83.985,196 L102,196 C103.65,196 105,194.65 105,193 L105,175 L96,166 Z M99,190 L87,190 L87,187 L99,187 L99,190 Z M99,184 L87,184 L87,181 L99,181 L99,184 Z M94.5,176.5 L94.5,168.25 L102.75,176.5 L94.5,176.5 Z",
    id: "Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentsInActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/documents_inActive.90eeedcb47e51b1dba010b8a5884aec9.svg";